//import 'bootstrap';
$(document).ready(() => {
  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");
  const searchBtn = document.querySelector("#search-btn");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");
  // check if the viewport is mobile or desktop
  let viewportWidth = $(window).width();
  window.addEventListener("resize", function () {
    viewportWidth = $(window).width();
  });

  // floating labels for gform inputs with top label
  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("focus", function () {
    // console.log("focusing");
    $(this).parent().parent(".gfield").addClass("active");
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("blur", function () {
    if ($(this).val().length == 0) {
      $(this).parent().parent(".gfield").removeClass("active");
    }
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).each(function () {
    if ($(this).val().length > 0) {
      // console.log("adding class active to input", $(this).val());
      $(this).parent().parent(".gfield").addClass("active");
    }
  });

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openMenu();
    },
    false
  );

  closeMenuBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeMenu();
    },
    false
  );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false
  );

  closeSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeSearch();
    },
    false
  );

  // opens the search
  function openSearch() {
    // console.log("opensearch function");
    searchModal.classList.remove("hidden");
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
  }

  // opens main nav
  function openMenu() {
    // console.log("opening nav");
    mainNav.classList.remove("translate-x-full");
    overlay.classList.remove("hidden");
    overlay.style.opacity = 0.75;
  }

  // closes main nav
  function closeMenu() {
    // console.log("closing nav");
    mainNav.classList.remove("translate-x-0");
    mainNav.classList.add("translate-x-full");
    overlay.classList.add("hidden");
    overlay.style.opacity = 0;
  }

  // header class
  function headerClass() {
    if (window.scrollY > 200) {
      document.querySelector("header").classList.add("scrolled");
    } else {
      document.querySelector("header").classList.remove("scrolled");
    }
  }

  // use headerHeight to set <main> margin top
  // function mtHeader() {
  //   let headerHeight = document.querySelector("header").offsetHeight;
  //   document.querySelector("main").style.marginTop = `${headerHeight}px`;
  // }
  // mtHeader();
  // window.addEventListener("resize", function () {
  //   mtHeader();
  // });
  // animate on scroll library
  AOS.init();

  var dropdowns = document.querySelectorAll(".dropdown");

  $("body").click(function () {
    //closeSearch();
    closeAllDropDowns();
  });
  headerClass();
  $(window).scroll(function () {
    headerClass();
    if (viewportWidth <= 1023) {
      // // console.log('mobile scroll')
      return;
    } else {
      // // console.log('desktop scroll')
      closeSearch();
      closeAllDropDowns();
    }
  });

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns() {
    $("header").removeClass("active");
    $(".underlay").removeClass("active");
    $(dropdowns).each(function () {
      $(this).removeClass("open");
    });
  }

  // on resize, reset this wiewport width
  $("header .dropdown > a").click(function (e) {
    if (viewportWidth <= 1023) {
      e.stopPropagation();

      if (!$(this).parent().hasClass("open")) {
        console.log("not .open already");
        e.preventDefault();
        // console.log("click click");
        closeAllDropDowns();
        //$('header').addClass('active'); $('.underlay').addClass('active');
        $(this).parent().addClass("open");
      } else {
        console.log(" .open already");
        if ($(this).attr("href") == "#") {
          console.log("href is #");
        } else {
          console.log("href is not #");
          return;
        }
        $(this).parent().removeClass("open");
      }
    }
  });

  // console.log("mobile view");

  $("header div.menu-item:not(.dropdown)").mouseenter(function () {
    if (viewportWidth >= 1024) {
      closeAllDropDowns();
    }
  });
  $("header .dropdown a").click(function (e) {
    if (viewportWidth >= 1024) {
      e.stopPropagation();
    }
  });
  $("header .dropdown").mouseenter(function () {
    if (viewportWidth >= 1024) {
      closeAllDropDowns();
      $("header").addClass("active");
      $(".underlay").addClass("active");
      $(this).addClass("open");
    }
  });

  /**
   * Line Group SIzing
   */
  const lineContainers = document.querySelectorAll(".line-container");
  function setLineContainerHeights() {
    console.log("setting line container height app.js");

    lineContainers.forEach((lineContainer) => {
      if (window.innerWidth < 1024) {
        lineContainer.style.height = `auto`;
      } else {
        let innerHeight = lineContainer.querySelector(".relative").offsetHeight;
        lineContainer.style.height = `${
          innerHeight + (14 - (innerHeight % 14))
        }px`;
      }
    });
  }
  setLineContainerHeights();
  setTimeout(() => {
    setLineContainerHeights();
  }, 1000);
  jQuery(document).on(
    "gform_post_render",
    function (event, form_id, current_page) {
      setLineContainerHeights();
      setTimeout(() => {
        setLineContainerHeights();
      }, 1000);
    }
  );
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    setLineContainerHeights();
  });
  window.onload = function () {
    setLineContainerHeights();
  };
  window.addEventListener("resize", function () {
    setLineContainerHeights();
  });

  /**
   * Vimeo players
   */
  const vimeoBlocks = document.querySelectorAll(".vimeo-block");
  vimeoBlocks.forEach((vimeoBlock) => {
    var iframe = vimeoBlock.querySelector("iframe");
    var mobileIframe = vimeoBlock.querySelector(".mobile-only iframe");

    if (iframe) {
      var player = new Vimeo.Player(iframe);
      player.on("loaded", setLineContainerHeights);
      // player.on('loaded') = function () {
      //   console.log("player loaded");
      // };
      let playBtns = vimeoBlock.querySelectorAll(".play-btn");
      // on click hide the buttons and play the video
      playBtns.forEach((element) => {
        element.addEventListener("click", function () {
          playBtns.forEach((btn) => {
            btn.style.transform = "scale(0)";
          });
          player.play();
        });
      });
      // on pause show the buttons
      player.on("pause", function () {
        playBtns.forEach((btn) => {
          btn.style.transform = "scale(1)";
        });
      });
      window.addEventListener("resize", function () {
        player.pause();
      });
    }
    if (mobileIframe) {
      var mPlayer = new Vimeo.Player(mobileIframe);
      mPlayer.on("loaded", setLineContainerHeights);
      // player.on('loaded') = function () {
      //   console.log("player loaded");
      // };
      let playBtns = vimeoBlock.querySelectorAll(".play-btn");
      // on click hide the buttons and play the video
      playBtns.forEach((element) => {
        element.addEventListener("click", function () {
          playBtns.forEach((btn) => {
            btn.style.transform = "scale(0)";
          });
          mPlayer.play();
        });
      });
      // on pause show the buttons
      mPlayer.on("pause", function () {
        playBtns.forEach((btn) => {
          btn.style.transform = "scale(1)";
        });
      });

      window.addEventListener("resize", function () {
        mPlayer.pause();
      });
    }
  });
});
// let vimeoPlayers = vimeoBlock.querySelectorAll(".vimeo-player");
// console.log('vimeoPlayers', vimeoPlayers);
// vimeoPlayers.forEach((player) => {
//   console.log('player', player);
//   var options = {
//     id: player.dataset.id,
//     width: 640,
//   };
//   var videoPlayer = new Vimeo.Player(player, options);
//   videoPlayer.on("loaded", setLineContainerHeights);
// });
